import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import useFranchiseHook from "@/shared/hooks/useFranchiseHook";
import { asArray, formatResponse } from "@/shared/utils/helpers";
import { useQuery } from "@tanstack/react-query";

const useFranchiseQuery = (enabled = true) => {
  const branchId = useBranchId();

  const [franchiseId] = useFranchiseHook();

  const query = useQuery({
    queryKey: [franchiseId, branchId, "franchise"],
    queryFn: () =>
      get2(`internal/secure/pos/v1/franchises/information/${franchiseId}`),
    refetchOnWindowFocus: false,
    enabled,
    select: (data) => {
      const ret = formatResponse(data.content);
      return {
        ...ret,
        languages: asArray(ret.languages),
      };
    },
  });
  return query;
};

export default useFranchiseQuery;
